import { BLOOD_PRESSURE_VIAL_ID } from '../constants';

const requireRecording = [BLOOD_PRESSURE_VIAL_ID];

function CalculateScannedCount(orders) {
  let tempScannedCount = 0;
  orders.forEach(({
    vials = [],
    blood_pressure,
    bpm,
    spo2,
    temperature,
  }) => {
    const vitalsReported = (
      String(blood_pressure).length !== 0
        || bpm !== 0
        || spo2 !== 0
        || temperature !== 0
    );
    vials.forEach((
      {
        barcode,
        reason_for_skip,
        vial_type,
      },
    ) => {
      if (barcode !== '' || reason_for_skip !== 9999) {
        tempScannedCount += 1;
      }
      // count vitals recorded
      if (requireRecording.includes(vial_type) && (vitalsReported || reason_for_skip !== 9999)) {
        tempScannedCount += 1;
      }
    });
  });
  return tempScannedCount;
}

export { CalculateScannedCount };
